import { MAIL_ITEM_CONTENT_TYPE } from './constants';
import { DownloadSmimeAttachmentEventName } from '../datapoints';
import { infobarMessageSMIMEUnknownErrorText } from '../strings.locstring.json';
import { saveAs } from 'file-saver';
import { logUsage } from 'owa-analytics';
import { isSmimeAttachmentType, TypeOfAttachment } from 'owa-attachment-model-store';
import getTypeOfAttachment from 'owa-attachment-model-store/lib/utils/getTypeOfAttachment';
import { confirm } from 'owa-confirm-dialog';
import createBlob from 'owa-encoding-utils/lib/utils/base64/createBlob';
import loc from 'owa-localize';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { trace } from 'owa-trace';

/**
 * Utility to download a S/MIME attachment.
 * @param attachment
 */
export default function downloadSmimeAttachment(attachment: AttachmentType) {
    try {
        if (isSmimeAttachmentType(attachment)) {
            const typeOfAttachment = getTypeOfAttachment(attachment);
            const isFileAttachment = typeOfAttachment === TypeOfAttachment.File;
            const content = isFileAttachment ? attachment.Content : attachment.MimeContent;
            const contentType = isFileAttachment ? attachment.ContentType : MAIL_ITEM_CONTENT_TYPE;
            const attachmentBlob = createBlob(content, contentType);
            saveAs(attachmentBlob, attachment.Name);
            logUsage(DownloadSmimeAttachmentEventName, { typeOfAttachment }, { isCore: true });
        } else {
            throw new Error(
                'downloadSmimeAttachment should only be invoked for S/MIME decoded attachments'
            );
        }
    } catch (e) {
        trace.error('SmimeTraceError: ' + e.message);
        confirm('', loc(infobarMessageSMIMEUnknownErrorText), false, {
            hideCancelButton: true,
        });
    }
}
